module.exports = __webpack_public_path__ + "static/media/icon-menu-up-end.c49b6ce4.svg";